const normalize = (value = '') => String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

const ALLERGY_LIKE_PATTERN = /\b(?:can(?:not|'?t) have|can't have|cannot have|reaction|reacted|allerg(?:y|ies|ic)|anaphylaxis|anaphylactic|flagged(?: it)?|flagged by (?:a |the )?(?:nurse|doctor|provider)|nurse flagged|doctor flagged)\b/i;

export const MANUAL_KNOWLEDGE_TYPES = new Set([
  'goal',
  'medication',
  'allergy',
]);

export const isManualKnowledgeSuggestion = (suggestion = {}) => (
  MANUAL_KNOWLEDGE_TYPES.has(normalize(suggestion.knowledgeType))
);

export const isPersonIdentityKnowledgeSuggestion = (suggestion = {}) => (
  normalize(suggestion.knowledgeType) === 'identity'
);

const getSafetyConsiderations = (source = {}) => {
  const rawSafety = source.suggestedProfileUpdates?.safetyConsiderations;
  const items = Array.isArray(rawSafety) ? rawSafety : [rawSafety];

  return items
    .map((item) => String(item || '').trim())
    .filter((item) => item && ALLERGY_LIKE_PATTERN.test(item));
};

export const getPersonIdentityProfileSuggestions = (source = {}) => {
  const safetyConsiderations = getSafetyConsiderations(source);
  const suggestions = [];

  if (safetyConsiderations.length) {
    suggestions.push({
      key: 'safetyConsiderations',
      label: 'Allergies',
      items: safetyConsiderations,
    });
  }

  return suggestions;
};
